import { defineMessages } from '@formatjs/intl';

export default defineMessages({
	message1: {
		id: 'freeTrialPlans.planSubtext.message1',
		defaultMessage: 'Subscriptions give you access to all Calm content.',
		description: 'Message 1 for plan subtext',
	},
	message2: {
		id: 'freeTrialPlans.planSubtext.message2',
		defaultMessage: 'You can cancel your subscription at any time.',
		description: 'Message 2 for plan subtext',
	},
});
